<template>
    <div class="video-footer" v-on:click="onDownClick()">
        <span>打开足趣社区，看更多相关精彩视频</span>
    </div>
</template>

<script>
    export default {
        props: {
            // 下载按钮点击事件
            onDownClick: [Function],
        }
    }
</script>

<style scoped>
    .video-footer{
        border: 1px solid #ff4a2d;
        color: #ff4a2d;
        margin: 10px 18px 38px;
        height: 42px;
        letter-spacing: 0;
        text-align: center;
        line-height: 42px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        border-radius: 22px;
    }
</style>